import { getSearchResults } from 'components/search-results/helper';
import itemActions from './items';
import * as gtm from '../../components/search-results/search-gtm';
import page from './page';
import ads from './ads';
import qs from 'qs';

const actionTypes = {
    REQUEST_SEARCH_RESULTS: 'SEARCH/REQUEST_SEARCH_RESULTS',
    RECEIVE_SEARCH_RESULTS: 'SEARCH/RECEIVE_SEARCH_RESULTS',
    ADD_SEARCH_RESULTS: 'SEARCH/ADD_SEARCH_RESULTS',
    LOCATION_CHANGE: 'SEARCH/ROUTER_DISPATCHED_ROUTE_CHANGE',
    UPDATE_ROUTING: 'SEARCH/UPDATE_ROUTING',
    SET_SINGLE_FILTER: 'SEARCH/SET_SINGLE_FILTER_VALUE',
    CHANGE_SORT_VALUE: 'SEARCH/CHANGE_SORT_VALUE',
    SET_ACTIVE_FILTER: 'SEARCH/SET_ACTIVE_FILTER',
    SET_ACTIVE_CATEGORY: 'SEARCH/SET_ACTIVE_CATEGORY'
};

const requestSearchResults = payload => ({
    type: actionTypes.REQUEST_SEARCH_RESULTS,
    payload
});

/**
 *
 * @param {object} payload the normalized version of the response
 */
const receiveSearchResults = payload => dispatch => {
    dispatch(page.setCategoryPath(payload.categoryPath));
    dispatch(page.setPageMeta(payload.reduxContainer.pageMeta));
    dispatch(ads.setAds(payload.reduxContainer.ads));
    const metaTitle = payload.pageMeta && payload.pageMeta.metaTitle;
    gtm.trackPageView(payload.categoryPath, payload.items, metaTitle);
    dispatch(itemActions.add(payload.items));
    return dispatch({
        type: actionTypes.RECEIVE_SEARCH_RESULTS,
        payload
    });
};

const fetchSearchResults = (endpoint, queryParams) => {
    return async (dispatch, getState) => {
        dispatch(requestSearchResults());
        const { initData } = getState();
        const searchResults = await getSearchResults(
            endpoint,
            queryParams,
            '',
            initData.version
        );
        dispatch(receiveSearchResults(searchResults.data));
        window.scrollTo({
            top: 0
        });
    };
};

const updateRouting = payload => ({
    type: actionTypes.UPDATE_ROUTING,
    payload
});

const historyLocationDidUpdate = history => (dispatch, getState) => {
    const routingState = getState().search.routing;
    const isPrevAndCurrentPathnameEqual = () => {
        return (
            routingState &&
            routingState.location.search === history.location.search &&
            routingState.location.pathname === history.location.pathname
        );
    };

    if (history.action === 'POP' && !isPrevAndCurrentPathnameEqual()) {
        dispatch(
            fetchSearchResults(
                location.pathname,
                qs.parse(history.location.search.substring(1))
            )
        );
    } else if (history.action === 'PUSH' && !isPrevAndCurrentPathnameEqual()) {
        dispatch(
            fetchSearchResults(
                location.pathname,
                qs.parse(history.location.search.substring(1))
            )
        );
    }
    dispatch(updateRouting(history));
};

const setSingleFilterValue = (filter, value) => {
    return {
        type: actionTypes.SET_SINGLE_FILTER,
        payload: {
            filter,
            value
        }
    };
};

const setActiveCategory = payload => ({
    type: actionTypes.SET_ACTIVE_CATEGORY,
    payload
});

export default {
    fetchSearchResults,
    requestSearchResults,
    receiveSearchResults,
    historyLocationDidUpdate,
    updateRouting,
    setSingleFilterValue,
    setActiveCategory,
    actionTypes
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/actions/search.js